import React from "react";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => {
    return {
        timer: {
            ...theme.typography.labelRegular,
            color: "#000",
            padding: "6px 8px",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            boxSizing: "border-box",
            height: "28px",
            borderRadius: "4px",
            marginRight: "2px",
            border: "1px solid rgba(0,0,0,0.1)",
            "@media (max-width: 300px)": {
                display: "none",
            },
        },
    };
});
/**
 * Returns web element to be rendered.
 *
 * @returns {ReactElement}
 */
export default function ConferenceTimerDisplay({ timerValue, textStyle: _textStyle }) {
    const { classes } = useStyles();
    return React.createElement("span", { className: classes.timer }, timerValue);
}
